<template>
    <ion-page>
        <ion-loading :is-open="busy" message="Loading, please wait"/>
        <ion-header>
            <ion-toolbar>
                <ion-buttons slot="end">
                    <ion-button @click="close()">
                        <ion-icon slot="icon-only" :icon="closeOutline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                <ion-title>Process Return</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <pull-down-refresh :callback="refresh" />
            <product-card-modal ref="product" :item="item.item" />
            <ion-list v-if="item && item.item">
                <ion-item v-if="item.is_amazon">
                    <ion-label>
                        <h2>Amazon Removal Order #</h2>
                        <p v-if="item.source">{{ item.source.removal_order_id.toUpperCase() }}
                            ({{ item.source.quantity_shipped }} / ({{ item.source.quantity }} shipped by Amazon)
                        </p>
                    </ion-label>
                </ion-item>
                <ion-item v-else>
                    <ion-label>Customer Return</ion-label>
                </ion-item>
                <ion-item detail button @click="showLocations()">
                    {{  currentLocationsLabel  }}
                </ion-item>
                <ion-item detail button @click="$refs['product'].open()">
                    {{ item.item.item_number }} Product Card
                </ion-item>
                <ion-item>
                    <ion-label align="center" class="small">
                        Recv'd<br />{{ item.qty_received }}
                    </ion-label>
                    <ion-label align="center" class="small">
                        Proc'd<br />
                        {{ itemsProcessed }}
                    </ion-label>
                    <ion-label align="center" class="small">
                        Ready<br />
                        {{ item.qty_ready_to_stack }}
                    </ion-label>
                    <ion-label align="center" class="small">
                        Relabel<br />
                        {{ item.qty_left_to_relabel }} / {{ item.qty_to_relabel }} left
                    </ion-label>
                    <ion-label align="center" class="small">
                        To Bin<br />
                        {{ item.qty_left_to_bin }} / {{ item.qty_to_bin }} left
                    </ion-label>
                </ion-item>
                <ion-item lines="none">
                    <big-stepper label="Qty Returned" v-model="qty_returned" :min="0" />
                </ion-item>
                <ion-item lines="none">
                    <big-stepper label="Qty Binned" v-model="qty_binned" :min="0" />
                </ion-item>
                <ion-item lines="none">
                    <big-stepper label="Qty Relabelled" v-model="qty_relabelled" :min="0" />
                </ion-item>
                <ion-item v-if="itemsRemaining > 0">
                    <ion-label align="center"><strong>{{ itemsRemaining }} items</strong> remaining to process</ion-label>
                </ion-item>
                <ion-item v-if="returnToStock > 0">
                    <ion-label class="ion-text-wrap">
                        <h2>Target Location</h2>
                        <p v-if="!location.code">Scan or search</p>
                        <p>{{ location.code }}</p>
                    </ion-label>
                    <ion-button size="medium" color="primary" @click="openLocationScanner('source')">
                        <ion-icon slot="icon-only" :icon="barcode"/>
                    </ion-button>
                    <ion-button v-if="web" expand="block" color="primary" size="medium" @click="openLocationPicker('source')">
                        <ion-icon slot="icon-only" :icon="search"/>
                    </ion-button>
                </ion-item>



            </ion-list>
        </ion-content>
        <ion-footer>
            <ion-button color="warning" class="ion-margin-top" size="large" expand="full" @click="save()">
                PROCESS
            </ion-button>
        </ion-footer>
    </ion-page>

</template>

<script>
import {
    IonContent,
    IonItem,
    IonList,
    IonLabel,
    IonPage,
    IonLoading,
    IonFooter,
    IonButton,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonTitle,
    modalController, alertController
} from "@ionic/vue";
import ProductCardModal from "@/components/Modals/ProductCardModal";
import PullDownRefresh from "@/components/PullDownRefresh";
import BigStepper from "@/components/BigStepper";
import {closeOutline, checkmarkCircle, search, barcode} from 'ionicons/icons';
import LocationSearchModalHelper from "@/services/LocationSearchModalHelper";
import {Capacitor} from "@capacitor/core";
import _ from 'lodash';

export default {
    name: "Process",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        BigStepper,
        PullDownRefresh,
        ProductCardModal,
        IonLoading,
        IonContent, IonItem, IonList, IonPage, IonLabel,
        IonFooter,
        IonButton,
        IonIcon,
        IonHeader,
        IonToolbar,
        IonButtons,
        IonTitle
    },
    props: {
        type: String,
        itemReturn: Object
    },
    mounted() {
        this.busy = true;
        this.refresh();
    },
    computed: {
        currentLocationsLabel() {
            if (this.item.item.locations && this.item.item.locations.length > 0) {
                return this.item.item.locations.length + ' current locations';
            }
            return 'No current locations';
        },
        itemsToBin() {
            return this.item.qty_to_bin - this.item.qty_binned;
        },
        itemsProcessed() {
            return this.item.qty_returned + this.item.qty_binned;
        },
        itemsToRelabel() {
            return this.item.qty_to_relabel - this.item.qty_relabelled;
        },
        itemsRemaining() {
            return this.item.qty_left_to_process - (1 * this.qty_returned) - (1 * this.qty_binned);
        },
        returnToStock() {
            // Casting to numbers by multiplying by 1
            return (1 * this.qty_returned);
        },
        web() {
            return Capacitor.platform === 'web';
        },
        hasSelectedLocation() {
            return this.location && this.location.id > 0;
        },

    },
    methods: {
        showLocations() {
            const locations = _(this.item.item.locations).map(loc => {
                return loc.code;
            }).join('<br />');
            alertController.create({
                header: 'Locations',
                message: locations,
                buttons: ['Ok']
            }).then(al => {
                al.present();
            });
        },
        close() {
            modalController.dismiss();
        },
        openLocationScanner() {
            this.$scanner.scan('location').then(result => {
                this.location = result.extra;
            });
        },
        openLocationPicker() {
            LocationSearchModalHelper.open().then(location => {
                this.location = location.data;
            });
        },
        reset() {
            this.location = {};
        },
        save() {
            this.busy = true;
            this.$http
                .put(`/api/returns/${this.itemReturn.id}`, {
                    qty_returned: this.qty_returned,
                    qty_binned: this.qty_binned,
                    qty_relabelled: this.qty_relabelled,
                    stack: this.location
                })
                .then(response => {
                    this.busy = false;
                    this.$toast.success("Returns processed");
                    this.refresh();
                    this.qty_relabelled = 0;
                    this.qty_binned = 0;
                    this.qty_returned = 0;
                    this.location = {};
                }).catch(error => {
                    this.busy = false;
                    this.$validationAlert(error);
                });

        },
        async refresh(event) {
            this.busy = true;
            await this.$nextTick();
            this.items = null;
            const payload = {
                include: 'source,item,item.locations'
            };
            this.$http
                .get('/api/returns/' + this.itemReturn.id, {params: payload})
                .then(response => {
                    this.item = response.data;
                }).catch(error => {
                    this.$validationAlert(error);
                }).finally(() => {
                    this.busy = false;
                    if (event && event.target.complete) {
                        event.target.complete();
                    }
                });
        }
    },
    data() {
        return {
            qty_returned: 0,
            qty_binned: 0,
            qty_relabelled: 0,
            item: {},
            busy: false,
            location: {}
        }
    },
    setup() {
        return {
            closeOutline, checkmarkCircle, search, barcode, modalController
        }
    }

}
</script>
<style scoped>
ion-label.small {
    font-size: 90%;
}
ion-badge {
    vertical-align: bottom;
}
ion-avatar {
    border-radius: 50%;
    background-color: var(--ion-color-primary);
    color: var(--ion-color-primary-contrast);
    font-weight: bold;
    display:flex;
}
</style>
